export default __webpack_public_path__ + "assets/logo-243e101c1c440ce41b0d5a1e039b4a44.png";